// Cross-widget resync after a content admin save. The save response carries
// the authoritative post-save record state (see ContentFormStateMapper); the
// top-level form's Alpine model consumes `payload.form` directly, but a few
// fields are owned by widgets outside that model (e.g. the featured-media
// persistence value, shared by both the wollimedia and simple drivers) and
// need their own listener to stay in sync.
export function registerContentFormSync() {
    window.addEventListener('content-form:synced', (event) => {
        const featuredMedia = event.detail?.featuredMedia;

        if (!featuredMedia || typeof featuredMedia.persistence !== 'string') {
            return;
        }

        document.querySelectorAll('[data-featured-media-persistence]').forEach((input) => {
            input.value = featuredMedia.persistence;
        });
    });
}
